import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';
import { EquipmentItem } from './equipment-item';

export class EquipmentClassType implements ViewModel , EquipmentItem {
  readonly friendlyTypeNameSingular = 'Equipment Class Type';
  readonly apiRoute: string = CONFIG.apiRoutes.equipmentClass;
  id: string;
  name: string;
  equipmentClassId: string;
  identifier: string;
  description: string;

  json() {
    return {
      id: this.id,
      name: this.name,
      equipmentClassId: this.equipmentClassId,
      identifier: this.identifier,
      description: this.description,

    };
  }

  public loadFromJson(data) {
    this.id = data.id;
    this.name = data.name;
    this.equipmentClassId = data.equipmentClassId;
    this.identifier = data.identifier;
    this.description = data.description;
  }
}
